import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config.js';

const config = resolveConfig(tailwindConfig);

export const getConfig = function getConfig(property, parser = null) {
  const value = property
    .split('.')
    .reduce((o, i) => (o && o.hasOwnProperty(i) ? o[i] : null), config.theme);

  switch (parser) {
    case 'px':
      return parseInt(value, 10);
    case 'ms-to-s':
      return parseInt(value, 10) / 1000;
    default:
      return value;
  }
};
